import { cloneElement } from 'react';

import { IFlat } from '../../common/model/flat.model';
import { Marker } from '../shared';

type Props = {
  flat: IFlat;
  isFocused: boolean;
  iconUrl: string;
  map: google.maps.Map;
  onMarkerClick: () => void;
};

const SearchMapMarker: React.FC<Props> = ({
  flat,
  isFocused,
  iconUrl,
  map,
  onMarkerClick,
}) => {
  return cloneElement(
    <Marker
      key={flat.id}
      position={{
        lat: flat.approximateLatitude,
        lng: flat.approximateLongitude,
      }}
      icon={{
        url: iconUrl,
        scaledSize: new google.maps.Size(42, 42),
      }}
      zIndex={isFocused ? 100 : 0}
      onClick={() => {
        onMarkerClick();
      }}
    />,
    { map }
  );
};

export default SearchMapMarker;
